import React, { useRef, useEffect } from "react";
import { menuDiagnose } from "./Datamenu_inc";
import { motion } from "framer-motion";
import { Tooltip } from "react-tooltip";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";

export const DataCenter_1 = () => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
      >
        <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
          <span className="drop-shadow-lg">{menuDiagnose[0].name}</span>
        </div>
        <div className="text-gray-500 flex flex-col justify-start gap-y-3">
          <span className="text-[#9E76B3] text-lg">
            ศูนย์อัลตร้าซาวน์ เปิดให้บริการสำหรับสัตว์เลี้ยงให้ดังนี้:
          </span>
          <li title="">
            การตรวจ Ultrasound ช่องท้อง: เพื่อประเมินอวัยวะภายใน เช่น ตับ, ไต,
            กระเพาะอาหาร, และลำไส้
          </li>
          <li title="">การตรวจ Ultrasound ช่องอก: เพื่อประเมินหัวใจและปอด</li>
          <li title="">
            การตรวจ Ultrasound ทางเดินปัสสาวะ:
            เพื่อประเมินกระเพาะปัสสาวะและท่อปัสสาวะ
          </li>
        </div>

        <div>
          <div className="text-xl mb-3 font-bold text-[#0F4D81]">
            <span>วันที่เปิดให้บริการ</span>
          </div>
          <div className="lg:flex grid grid-cols-1 justify-start items-center gap-4">
            <div className="flex flex-col gap-y-2">
              <div className="bg-yellow-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> จันทร์
                </p>
              </div>
              <div className="bg-yellow-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-pink-400 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> อังคาร
                </p>
              </div>
              <div className="bg-pink-400 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-green-600 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> พุธ
                </p>
              </div>
              <div className="bg-green-600 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-orange-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> พฤหัสบดี
                </p>
              </div>
              <div className="bg-orange-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-cyan-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> <span>ศุกร์</span>
                </p>
              </div>
              <div className="bg-cyan-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Tooltip */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="absolute top-1/2 right-0 transform -translate-x-1/2 -translate-y-1/2"
      >
        <div className=" h-full w-full">
          <div className="flex flex-col px-3 py-2 gap-y-2">
            <div
              onClick={() => window.open("tel:053948031")}
              className="
            bg-[#0F4D81] text-white hover:bg-blue-900 cursor-pointer 
            w-10 h-10 rounded-full flex items-center justify-center
            "
              data-tooltip-id="call-tooltip"
            >
              <i className="fa fa-phone"></i>
            </div>
            <Tooltip id="call-tooltip" place="right" content="0 5394 8031" />
            <div
              onClick={() =>
                window.open("mailto:novel.vmcmu.serivce@gmail.com", "_blank")
              }
              className="bg-red-500 text-white hover:bg-red-800 cursor-pointer
             w-10 h-10 rounded-full flex items-center justify-center"
              data-tooltip-id="email-tooltip"
            >
              <i className="fa fa-envelope"></i>
            </div>
            <Tooltip
              id="email-tooltip"
              place="right"
              content="novel.vmcmu.serivce@gmail.com"
            />
          </div>
        </div>
      </motion.div>
    </>
  );
};
export const DataCenter_2 = () => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
      >
        <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
          <span className="drop-shadow-lg">{menuDiagnose[1].name}</span>
        </div>
        <div className="text-gray-500 flex flex-col justify-start gap-y-3">
          <span className="text-[#9E76B3] text-lg">
            บริการ X-ray สำหรับสัตว์เลี้ยงให้บริการดังนี้:
          </span>
          <li title="">
            🦴 การตรวจ X-ray: เพื่อวินิจฉัยโรคและความผิดปกติต่างๆ เช่น
            กระดูกหัก, โรคข้อเสื่อม, และปัญหาทางเดินหายใจ
          </li>
          <li title="">
            🏥 การตรวจ X-ray ช่องท้อง: เพื่อประเมินอวัยวะภายใน เช่น ตับ, ไต,
            และลำไส้
          </li>
          <li title="">❤️ การตรวจ X-ray ช่องอก: เพื่อประเมินหัวใจและปอด</li>
          <li title="">
            🦷 การตรวจ X-ray ช่องปากและฟัน: เพื่อวินิจฉัยปัญหาทางทันตกรรม
          </li>
        </div>

        <div>
          <div className="text-xl mb-3 font-bold text-[#0F4D81]">
            <span>วันที่เปิดให้บริการ</span>
          </div>
          <div className="lg:flex grid grid-cols-1 justify-start items-center gap-4">
            <div className="flex flex-col gap-y-2">
              <div className="bg-yellow-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> จันทร์
                </p>
              </div>
              <div className="bg-yellow-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-pink-400 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> อังคาร
                </p>
              </div>
              <div className="bg-pink-400 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-green-600 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> พุธ
                </p>
              </div>
              <div className="bg-green-600 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-orange-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> พฤหัสบดี
                </p>
              </div>
              <div className="bg-orange-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-cyan-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> <span>ศุกร์</span>
                </p>
              </div>
              <div className="bg-cyan-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
      {/* Tooltip */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="absolute top-1/2 right-0 transform -translate-x-1/2 -translate-y-1/2"
      >
        <div className=" h-full w-full">
          <div className="flex flex-col px-3 py-2 gap-y-2">
            <div
              onClick={() => window.open("tel:053948031")}
              className="
            bg-[#0F4D81] text-white hover:bg-blue-900 cursor-pointer 
            w-10 h-10 rounded-full flex items-center justify-center
            "
              data-tooltip-id="call-tooltip"
            >
              <i className="fa fa-phone"></i>
            </div>
            <Tooltip id="call-tooltip" place="right" content="0 5394 8031" />
            <div
              onClick={() =>
                window.open("mailto:novel.vmcmu.serivce@gmail.com", "_blank")
              }
              className="bg-red-500 text-white hover:bg-red-800 cursor-pointer
             w-10 h-10 rounded-full flex items-center justify-center"
              data-tooltip-id="email-tooltip"
            >
              <i className="fa fa-envelope"></i>
            </div>
            <Tooltip
              id="email-tooltip"
              place="right"
              content="novel.vmcmu.serivce@gmail.com"
            />
          </div>
        </div>
      </motion.div>
    </>
  );
};
export const DataCenter_3 = () => {
  const containerRef = useRef(null);
  const viewerInstance = useRef(null);

  useEffect(() => {
    // Initialize Viewer.js สำหรับ container
    if (containerRef.current && !viewerInstance.current) {
      viewerInstance.current = new Viewer(containerRef.current, {
        inline: false,
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          oneToOne: 1,
          reset: 1,
          prev: 1,
          play: 0,
          next: 1,
          rotateLeft: 1,
          rotateRight: 1,
          flipHorizontal: 1,
          flipVertical: 1,
        },
      });
    }
    return () => {
      // ทำลาย Instance เมื่อ Component ถูกลบ
      if (viewerInstance.current) {
        viewerInstance.current.destroy();
        viewerInstance.current = null;
      }
    };
  }, []);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
      >
        <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
          <span className="drop-shadow-lg">{menuDiagnose[2].name}</span>
          <span className="text-lg">
            ศูนย์เอกซเรย์คอมพิวเตอร์สำหรับสัตว์เลี้ยง คณะสัตวแพทยศาสตร์ มช.
          </span>
        </div>
        <div className="text-gray-500 flex flex-col justify-start gap-y-3">
          <span className="text-[#9E76B3] text-lg">
            บริการเอกซเรย์คอมพิวเตอร์ของเราเริ่มต้นที่ 5,000 บาท/ ครั้ง
            โดยราคานี้จะเป็นการให้บริการแบบ CT scan 1 Part (1 ส่วน)
            ไม่รวมค่าหัตถการ ค่าอุปกรณ์ต่าง ๆ และการฉีดสารทึบรังสี
            โดยจะมีการเปลี่ยนแปลงไปตามน้ำหนัก และดุลยพินิจของสัตวแพทย์เจ้าของไข้
          </span>
          <li title="">
            ทางศูนย์เอกซเรย์คอมพิวเตอร์สำหรับสัตว์เลี้ยงของเราได้ติดตั้งเครื่องเอกซเรย์คอมพิวเตอร์ที่มีประสิทธิภาพสูงที่สามารถสร้างภาพได้สูงถึง
            390 ภาพต่อการสแกน 1 รอบ
            ซึ่งทำให้ได้ความละเอียดของภาพดีที่สุดและยังลดปริมาณรังสีที่ได้รับอีกด้วย
          </li>
          <li>
            ปัจจุบันมีสัตว์เลี้ยงแสนน่ารักเข้ามาใช้บริการของเรา
            และได้เข้ารับการรักษากับทางสัตวแพทย์อย่างตรงจุด
            ทางศูนย์เอกซเรย์คอมพิวเตอร์สัตว์เลี้ยงจึงขอขอบพระคุณทุกท่านที่ไว้วางใจในการบริการของเรา
            และเรายินดีให้บริการเอกซ์เรย์คอมพิวเตอร์ให้กับสัตว์เลี้ยงทุกชนิด
          </li>
        </div>
        <div className="lg:grid grid-cols-6 hidden justify-start gap-3">
          <div className="relative group shadow-md rounded-md overflow-hidden">
            <img
              ref={containerRef}
              src="/images/ct-scan/1.jpg"
              alt="CT scan showing chest cavity"
              className="object-cover w-full h-auto"
            />
            <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center bg-black/50 h-0 group-hover:h-full transition-all duration-300 ease-in-out">
              <div
                onClick={() => {
                  if (viewerInstance.current) {
                    viewerInstance.current.show();
                  }
                }}
                className="bg-gray-400/50 text-gray-100 px-2 py-1 rounded-md shadow-lg text-[14px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
              >
                View image
              </div>
            </div>
          </div>
          <div className="relative group shadow-md rounded-md overflow-hidden">
            <img
              ref={containerRef}
              src="/images/ct-scan/2.jpg"
              alt="CT scan showing chest cavity2"
              className="object-cover w-full h-auto"
            />
            <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center bg-black/50 h-0 group-hover:h-full transition-all duration-300 ease-in-out">
              <div
                onClick={() => {
                  if (viewerInstance.current) {
                    viewerInstance.current.show();
                  }
                }}
                className="bg-gray-400/50 text-gray-100 px-2 py-1 rounded-md shadow-lg text-[14px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
              >
                View image
              </div>
            </div>
          </div>
          <div className="relative group shadow-md rounded-md overflow-hidden">
            <img
              ref={containerRef}
              src="/images/ct-scan/3.jpg"
              alt="CT scan showing chest cavity3"
              className="object-cover w-full h-auto"
            />
            <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center bg-black/50 h-0 group-hover:h-full transition-all duration-300 ease-in-out">
              <div
                onClick={() => {
                  if (viewerInstance.current) {
                    viewerInstance.current.show();
                  }
                }}
                className="bg-gray-400/50 text-gray-100 px-2 py-1 rounded-md shadow-lg text-[14px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
              >
                View image
              </div>
            </div>
          </div>
          <div className="relative group shadow-md rounded-md overflow-hidden">
            <img
              ref={containerRef}
              src="/images/ct-scan/4.jpg"
              alt="CT scan showing chest cavity4"
              className="object-cover w-full h-auto"
            />
            <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center bg-black/50 h-0 group-hover:h-full transition-all duration-300 ease-in-out">
              <div
                onClick={() => {
                  if (viewerInstance.current) {
                    viewerInstance.current.show();
                  }
                }}
                className="bg-gray-400/50 text-gray-100 px-2 py-1 rounded-md shadow-lg text-[14px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
              >
                View image
              </div>
            </div>
          </div>
          <div className="relative group shadow-md rounded-md overflow-hidden">
            <img
              ref={containerRef}
              src="/images/ct-scan/5.jpg"
              alt="CT scan showing chest cavity5"
              className="object-cover w-full h-auto"
            />
            <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center bg-black/50 h-0 group-hover:h-full transition-all duration-300 ease-in-out">
              <div
                onClick={() => {
                  if (viewerInstance.current) {
                    viewerInstance.current.show();
                  }
                }}
                className="bg-gray-400/50 text-gray-100 px-2 py-1 rounded-md shadow-lg text-[14px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
              >
                View image
              </div>
            </div>
          </div>
          <div className="relative group shadow-md rounded-md overflow-hidden">
            <img
              ref={containerRef}
              src="/images/ct-scan/6.jpg"
              alt="CT scan showing chest cavity6"
              className="object-cover w-full h-auto"
            />
            <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center bg-black/50 h-0 group-hover:h-full transition-all duration-300 ease-in-out">
              <div
                onClick={() => {
                  if (viewerInstance.current) {
                    viewerInstance.current.show();
                  }
                }}
                className="bg-gray-400/50 text-gray-100 px-2 py-1 rounded-md shadow-lg text-[14px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
              >
                View image
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="text-xl mb-3 font-bold text-[#0F4D81]">
            <span>วันที่เปิดให้บริการ</span>
          </div>
          <div className="lg:flex grid grid-cols-1 justify-start items-center gap-4">
            <div className="flex flex-col gap-y-2">
              <div className="bg-yellow-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> จันทร์
                </p>
              </div>
              <div className="bg-yellow-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-pink-400 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> อังคาร
                </p>
              </div>
              <div className="bg-pink-400 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-green-600 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> พุธ
                </p>
              </div>
              <div className="bg-green-600 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-orange-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> พฤหัสบดี
                </p>
              </div>
              <div className="bg-orange-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-cyan-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> <span>ศุกร์</span>
                </p>
              </div>
              <div className="bg-cyan-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
      {/* Tooltip */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="absolute top-1/2 right-0 transform -translate-x-1/2 -translate-y-1/2"
      >
        <div className=" h-full w-full">
          <div className="flex flex-col px-3 py-2 gap-y-2">
            <div
              onClick={() => window.open("tel:0817451935")}
              className="
            bg-[#0F4D81] text-white hover:bg-blue-900 cursor-pointer 
            w-10 h-10 rounded-full flex items-center justify-center
            "
              data-tooltip-id="call-tooltip"
            >
              <i className="fa fa-phone"></i>
            </div>
            <Tooltip id="call-tooltip" place="right" content="08 1745 1935" />
            <div
              onClick={() =>
                window.open("mailto:ctvetcmu@nvtec.co.th", "_blank")
              }
              className="bg-red-500 text-white hover:bg-red-800 cursor-pointer
             w-10 h-10 rounded-full flex items-center justify-center"
              data-tooltip-id="email-tooltip"
            >
              <i className="fa fa-envelope"></i>
            </div>
            <Tooltip
              id="email-tooltip"
              place="right"
              content="ctvetcmu@nvtec.co.th"
            />

            <div
              className="bg-green-600 text-white hover:bg-red-800 cursor-pointer
             w-10 h-10 rounded-full flex items-center justify-center"
              data-tooltip-id="line-tooltip"
            >
              <i className="fa-brands fa-line"></i>
            </div>
            <Tooltip
              id="line-tooltip"
              place="right"
              content="Line ID: 0817451935"
            />
          </div>
        </div>
      </motion.div>
    </>
  );
};
